import PageTitle from "../../common/pagetitle/pagetitle";
import React, {useEffect, useState} from "react";
import axios from "axios";
import { serverLink} from "../../url";
import {showAlert, showConfirm} from "../../common/sweetalert/sweetalert";
import {toast} from "react-toastify";
import {connect} from "react-redux";
import DataTable from "../../common/data-table/data-table";
import Loader from "../../common/loader";
import {Link} from "react-router-dom";

function LabTest(props) {
    const token = props.loginData[0]?.token;
    const [IsLoading, setIsLoading] = useState(true)
    const [IsFormLoading, setIsFormLoading] = useState(false)
    const [laboratoryList, setLaboratoryList] = useState([])
    const [blockList, setBlockList] = useState([])
    const header = ["S/N", "Test Name", "Laboratory Name", "Specimen", "Price",  "Edit", "Delete"];
    const initialValue = {
        laboratoryID: "",
        laboratoryName: "",
        labType: "",
        laboratoryAddress: "",
        blockID: "",
        submittedBy: `${props.loginData[0]?.userID}`,
    }
    const [formData, setFormData] = useState(initialValue)

    const resetForm = () => {
        setFormData(initialValue)
    }


    useEffect( () => {
        getData();
    }, [""]);


    const getData = async () => {
        await axios.get(`${serverLink}laboratory/list/all`, token)
            .then((result) => {
                if (result.data.message === 'success') {
                    setLaboratoryList(result.data.lab);
                    setBlockList(result.data.block);
                }else {
                    setLaboratoryList([])
                }
                setIsLoading(false)
            })
            .catch((err) => {
                console.log("NETWORK ERROR");
            });
    }


    const delete_item = async (id) => {
        toast.info("please wait...");
        await axios.delete(`${serverLink}laboratory/delete/${id}`).then((res) => {
            if (res.data.message === "success") {
                toast.success("Deleted Successfully");
                getData();
            } else {
                toast.error("NETWORK ERROR. Please try again!");
            }
        }).catch((err) => {
            console.log(err);
            toast.error("NETWORK ERROR. Please try again!");
        });
    }

    const  showTable = () => {
        try {
            return laboratoryList.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{index +1}</td>
                        <td>{item.testName}</td>
                        <td>{item.laboratoryName}</td>
                        <td>{item.specimeName}</td>
                        <td>{item.testAmount}</td>
                        <td>
                            <a href="#" className={"btn btn-primary btn-sm "} data-toggle="modal" data-target="#responsive-modal"
                               onClick={() => {
                                   setFormData({
                                       ...formData,
                                       laboratoryID: item.laboratoryID,
                                       laboratoryName: item.laboratoryName,
                                       labType: item.labType,
                                       blockID: item.blockID,
                                       laboratoryAddress: item.laboratoryAddress,
                                   });
                               }}>
                                Edit
                            </a></td>
                        <td>
                            <a href="#" className={"btn btn-danger btn-sm "}
                               onClick={()=>showConfirm("Warning", `Are you sure you want to delete this lab?`, "warning")
                                   .then( async (confirm) => {
                                       if (confirm) {
                                           delete_item(item.laboratoryID)
                                       }
                                   })}>
                                Delete
                            </a></td>
                    </tr>
                );
            });
        } catch (e) {
            alert(e.message);
        }
    };

    const onEdit = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value,
        });
    }

    const onSubmit = async () => {
        if (formData.laboratoryName.toString().trim() === "") {
            showAlert("EMPTY FIELD", "Please enter laboratory name", "error");
            return false;
        }

        if (formData.labType.toString().trim() === "") {
            showAlert("EMPTY FIELD", "Please enter laboratory type", "error");
            return false;
        }

        if (formData.blockID.toString().trim() === "") {
            showAlert("EMPTY FIELD", "Please select laboratory block", "error");
            return false;
        }


        if (formData.laboratoryID === "") {
            let sendData = {
                ...formData,
            }
            setIsFormLoading(true);
            toast.info("please wait...");
            await axios
                .post(`${serverLink}laboratory/add`, sendData, token)
                .then((result) => {
                    if (result.data.message === "success") {
                        toast.success("Laboratory Added Successfully");
                        setIsFormLoading(false);
                        getData();
                        document.getElementById("close").click();
                        resetForm()
                    } else {
                        setIsFormLoading(false);
                        showAlert(
                            "ERROR",
                            "Something went wrong. Please try again!",
                            "error"
                        );
                    }
                })
                .catch((error) => {
                    setIsFormLoading(false);
                    showAlert(
                        "NETWORK ERROR",
                        "Please check your connection and try again!",
                        "error"
                    );
                });
        }else{
            let sendData = {
                ...formData,
            }
            setIsFormLoading(true);
            await axios
                .patch(`${serverLink}laboratory/update`, sendData, token)
                .then((result) => {
                    if (result.data.message === "success") {
                        toast.success("Laboratory Updated Successfully");
                        setIsFormLoading(false);
                        getData();
                        document.getElementById("close").click();
                        resetForm()
                    } else {
                        setIsFormLoading(false);
                        showAlert(
                            "ERROR",
                            "Something went wrong. Please try again!",
                            "error"
                        );
                    }
                })
                .catch((error) => {
                    setIsFormLoading(false);
                    showAlert(
                        "NETWORK ERROR",
                        "Please check your connection and try again!",
                        "error"
                    );
                });
        }
    }

    return(IsLoading ? <Loader/> :
            <>
                <PageTitle title={["Home", "Lab Test"]} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title">Manage Lab Test</h4>
                                    <div className="d-flex no-block align-items-center m-b-30 mt-3">
                                        <div className="ml-auto">
                                            <div className="btn-group">
                                                <Link to="/lab/test-page" className="btn btn-info">
                                                    <i className="fa fa-plus"></i> Add Lab Test
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <DataTable tableID="Lab-Test" header={header} body={showTable()} title="Lab Test Report"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
    )
}

const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
    };
};
export default connect(mapStateToProps, null)(LabTest);

